import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const satisfactionAPI = axios.create({
  baseURL: `${API_BASE_URL}/satisfaction`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: { 'Content-Type': 'application/json' },
});

const errorMessage = (error, fallback) =>
  error.response?.data?.message || fallback;

export const satisfactionService = {
  // Datos de la encuesta (reserva, si ya se respondió, link de Google)
  getSurvey: async (token) => {
    try {
      const response = await satisfactionAPI.get(`/survey/${token}`);
      return response.data;
    } catch (error) {
      throw new Error(errorMessage(error, 'No pudimos cargar la encuesta.'));
    }
  },

  // Envía las respuestas. Respuesta: { ok, showGoogle, googleUrl }
  respond: async (token, answers) => {
    try {
      const response = await satisfactionAPI.post(`/survey/${token}/respond`, answers);
      return response.data;
    } catch (error) {
      throw new Error(errorMessage(error, 'No pudimos guardar tus respuestas.'));
    }
  },

  // Registra que el huésped abrió el link de reseña de Google
  trackGoogleClick: async (token) => {
    try {
      await satisfactionAPI.post(`/survey/${token}/google-click`);
    } catch {
      /* no es crítico */
    }
  },
};

export default satisfactionService;
